/**
 * Checks if a product is only available in physical stores and therefore not purchasable online.
 *
 * The flag reaches the frontend with two different encodings: a real boolean when the Liquid
 * template serializes the metafield value, and the string 'true' when it comes from the
 * Storefront API metafield.
 *
 * @param storeExclusive - Raw value of the `custom.store_exclusive` product metafield.
 * @returns True if the product is store exclusive, false otherwise.
 */
export const isStoreExclusiveProduct = ({
  storeExclusive,
}: {
  storeExclusive?: boolean | string | null
}): boolean => {
  if (typeof storeExclusive === 'string') {
    return storeExclusive.trim().toLowerCase() === 'true'
  }

  return storeExclusive === true
}
